import gql from 'graphql-tag';

import { CartEntryFragment } from 'remote/queries/fragments/cart-entry';
import VendorConfigsFragment from 'remote/queries/fragments/vendor-configs';

const DetailsFragment = gql`
  fragment DetailsFragment on UserDetails {
    name
    dob
    phoneNumber
    email
    emailVerified
    promotionalEmails
    isoCountryCode
    zipcode
    defaultAccountIdentifier
    defaultFdAccountId
    defaultPaymentAccountId
    defaultReloadAmt
    autoReloadEnabled
    autoReloadThreshold
    deliveryAddresses {
      addressLine1
      addressLine2
      city
      country
      phoneNumber
      state
      zip
    }
    communicationPreferences {
      id
      value
    }
    favoriteStores {
      storeId
    }
    loyaltyTier
  }
`;

export const getMeQuery = gql`
  query GetMe($numUniquePurchasedItems: Int, $customInput: MeInput) @authRequired {
    me(numUniquePurchasedItems: $numUniquePurchasedItems, customInput: $customInput) {
      thLegacyCognitoId
      cognitoId
      details {
        ...DetailsFragment
      }
      loyaltyId
      uniquePurchasedItems {
        name
        image
        lineId
        sanityId
        quantity
        type
        price
        url
        pickerSelections
        vendorConfigs {
          ...VendorConfigsFragment
        }
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
                children {
                  ...CartEntryFragment
                  children {
                    ...CartEntryFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  ${DetailsFragment}
  ${CartEntryFragment}
  ${VendorConfigsFragment}
`;

export const signInKioskUserMutation = gql`
  mutation kioskSignInUser($input: SignInUserInput!) {
    kioskSignIn(userInfo: $input) {
      decryptedCode
      sessionId
    }
  }
`;
